const MUNTERS_MERCURY_GATE_LOAD_ID_PATTERN = /\bLD\d+\b/i;

// Extracts the first MercuryGate LD reference from form or email text.
export function normalizeMercuryGateLoadId(raw: string): string {
  const loadId = raw.trim().match(MUNTERS_MERCURY_GATE_LOAD_ID_PATTERN)?.[0];

  return loadId?.toUpperCase() ?? '';
}
